<script lang="ts">
import { computed, defineComponent, h, unref } from 'vue';

import { makeLinkProps, makeTextProps, makeThemeProps, useLink, useRender } from '../../composable';
import { CdsLink } from '../CdsLink';

import type { PropType } from 'vue';

export const componentName = 'CdsBreadcrumbsItem';
export default defineComponent({
  name: componentName,
  props: {
    /**
     * Является ли элемент текущей страницей
     */
    currentPage: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    ...makeTextProps(),
    ...makeLinkProps(),
    ...makeThemeProps()
  },
  setup(props, { slots, emit }) {
    const { isLink, href, to } = useLink(props, emit);

    const isInternalLink = computed(() => !props.currentPage && unref(isLink));
    const title = computed(() => props.text || '');

    useRender(() =>
      h('li', { class: 'cds-breadcrumbs__item' }, [
        unref(isInternalLink)
          ? h(
              CdsLink,
              {
                text: unref(title),
                to: props.to && unref(to),
                href: props.href && unref(href),
                title: unref(title),
                theme: props.theme
              },
              { default: () => slots.default?.() }
            )
          : h('span', { title: unref(title) }, [unref(title), slots.default?.()])
      ])
    );

    return {};
  }
});
</script>
